import { WorkingStepIconSvg } from 'components/Common/WorkingSteps/WorkingStepIcon'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { ListItemAvatar, ListItemText, MenuItem } from '@material-ui/core'
import { useAppDispatch, useAppSelector } from 'store/configureStore'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { useTranslation } from 'react-i18next'
import { useDialogManager } from 'features/DialogManager/DialogManager'
import { PurchasingPartDialogProps } from 'features/PurchasingPartDetails/PurchasingPartDetails'
import { saveBomItemIsPurchasingPart } from 'features/BillOfMaterials/store/asyncActions/saveBomItemIsPurchasingPart'
import { BomItemPricePerBatch } from 'features/BillOfMaterials/components/BomItemPricePerBatch'

export const PurchasingPartMenuItem = ({
  bomItemId,
  variant,
  onClose,
}: {
  bomItemId?: string
  variant: 'toggle' | 'modal'
  onClose?: () => void
}) => {
  const isPurchasingPart = useAppSelector((state) => {
    if (!bomItemId) {
      return projectSelectors.bomItemIsPurchasingPartSelector(
        state.project?.selectedBomItemIds[0]
      )(state)
    }
    return projectSelectors.bomItemIsPurchasingPartSelector(bomItemId)(state)
  })

  const dispatch = useAppDispatch()

  const { t } = useTranslation()

  const { openDialog } = useDialogManager()

  const openPurchasingPartDialog = () => {
    onClose && onClose()
    openDialog('PurchasingPartDialog', {
      bomItemId,
      isOpen: true,
    } as PurchasingPartDialogProps)
  }

  const handleTogglePurchasingPart = () => {
    dispatch(saveBomItemIsPurchasingPart({ bomItemId }))
  }

  const handleClick = () => {
    if (variant === 'toggle') {
      handleTogglePurchasingPart()
    }
    if (variant === 'modal') {
      openPurchasingPartDialog()
    }
  }

  const PrimaryComponent = () => {
    if (!bomItemId) {
      return (
        <>
          {t(
            'project:purchasing-part-set-unset',
            'set or unset as purchasing part'
          )}
        </>
      )
    }

    if (isPurchasingPart) {
      if (bomItemId) {
        return <BomItemPricePerBatch bomItemId={bomItemId} fullWidth />
      } else
        return (
          <>{t('project:purchasing-part-unset', 'unset as purchasing part')}</>
        )
    } else {
      return <>{t('project:purchasing-part-set', 'set as purchasing part')}</>
    }
  }

  return (
    <MenuItem onClick={handleClick}>
      <ListItemAvatar>
        <WorkingStepIconSvg
          workingStepType={WorkingStepType.Purchasing}
          attributes={{
            width: '2rem',
          }}
        />
      </ListItemAvatar>
      <ListItemText
        primary={<PrimaryComponent />}
        secondary={t(
          'project:purchasing-part-set-desc',
          'manual set price/batch'
        )}
      />
    </MenuItem>
  )
}
